import { getServiceUrl, httpGet } from '../services/api';
import { LoyaltyProgress } from './loyalty/types';

const getUrl = (url) => getServiceUrl('loyalty', url);

export async function getLoyaltyProgress() {
    const url = getUrl('loyalist/my-progress');
    return httpGet<LoyaltyProgress>(url);
}
